import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export const getSharesTitlesByShares =
  (sharesIds: string[]) => async (dispatch: any) => {
    const body = { sharesIds };

    try {
      const { data } = await axiosV2.post('/sharesTitles/shares', body);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
